import { createMuiTheme } from '@material-ui/core';
import { StylesProvider, ThemeProvider } from '@material-ui/styles';
import React, { FC } from 'react';
import 'typeface-open-sans';

function pxToRem(px: number) {
  return `${px / 16}rem`;
}

const theme = createMuiTheme({
  typography: {
    fontFamily: 'Open Sans, Helvetica Neue, Arial, sans-serif',
    h5: {
      fontSize: pxToRem(28),
    },
  },
  palette: {
    primary: {
      main: '#b2449a',
    },
    secondary: {
      main: '#3a1466',
    },
  },
});

const MuiThemeProvider: FC = ({ children }) => (
  <StylesProvider injectFirst>
    <ThemeProvider theme={theme}>{children}</ThemeProvider>
  </StylesProvider>
);

export default MuiThemeProvider;
